import { DateISOStringPipeModule } from '@toro/common/shared/pipes/date-iso-string/date-iso-string.module';
import { MarkdownToHtmlPipeModule } from '@toro/common/shared/pipes/markdown/markdown.module';
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { CheckoutTermAcceptSidePanelComponent } from "./checkout-term-accept-aside-panel.component";
import { TrCheckboxModule } from "@toro/common/shared/components";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from '../../../components/components.module';
import { GlobalModule } from '../../../global.module';

@NgModule({
    imports: [
        SvgIconModule,
        CommonModule,
        RouterModule,
        TrCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        MarkdownToHtmlPipeModule,
        ComponentsModule,
        GlobalModule,
        DateISOStringPipeModule
    ],
    declarations: [
        CheckoutTermAcceptSidePanelComponent
    ],
    exports: [
        CheckoutTermAcceptSidePanelComponent
    ],
    entryComponents: [
        CheckoutTermAcceptSidePanelComponent
    ]
})
export class CheckoutTermAcceptSidePanelModule {}